import { ShieldCheck } from "lucide-react";

const APP = "Auto Detail Manager";

const DOCS = {
  cgu: {
    title: "Conditions Générales d'Utilisation",
    testid: "legal-cgu",
    sections: [
      ["1. Objet", `Les présentes CGU régissent l'accès et l'utilisation du logiciel de gestion ${APP} (le « Service »), édité en mode SaaS à destination des professionnels du detailing automobile.`],
      ["2. Compte & essai gratuit", "La création d'un compte ouvre un essai gratuit de 14 jours, sans carte bancaire. À l'issue de l'essai, l'accès au Service nécessite un abonnement actif. Chaque compte est rattaché à une entreprise ; les données de chaque entreprise sont strictement isolées."],
      ["3. Abonnement & facturation", "L'abonnement est mensuel, sans engagement, résiliable à tout moment depuis l'espace « Mon abonnement ». Les paiements sont traités par notre prestataire Stripe. En cas d'échec de paiement, l'accès peut être suspendu sans perte de données."],
      ["4. Obligations de l'utilisateur", "L'utilisateur s'engage à fournir des informations exactes, à préserver la confidentialité de ses identifiants et à utiliser le Service conformément à la législation en vigueur (notamment en matière de facturation et d'obligations sociales)."],
      ["5. Disponibilité & responsabilité", "L'éditeur met tout en œuvre pour assurer la disponibilité du Service mais ne saurait être tenu responsable des interruptions indépendantes de sa volonté. L'utilisateur reste seul responsable de ses déclarations fiscales et sociales."],
      ["6. Résiliation & suppression", "L'utilisateur peut fermer son compte à tout moment. Les données personnelles sont supprimées après un délai de grâce de 30 jours ; les factures et pièces comptables sont conservées conformément aux obligations légales (10 ans)."],
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    testid: "legal-confidentialite",
    sections: [
      ["1. Responsable du traitement", `${APP} agit en tant que sous-traitant des données saisies par chaque entreprise cliente (clients, véhicules, devis, factures). L'entreprise cliente reste responsable de traitement de ses propres données.`],
      ["2. Données collectées", "Données de compte (nom, email, téléphone), données d'entreprise (raison sociale, SIREN/SIRET, adresse) et données métier saisies par l'utilisateur. Aucune donnée n'est vendue à des tiers."],
      ["3. Finalités", "Fournir le Service, gérer l'abonnement, assurer le support et respecter nos obligations légales."],
      ["4. Base légale", "Exécution du contrat (fourniture du Service), obligations légales (comptabilité) et intérêt légitime (sécurité, amélioration du Service)."],
      ["5. Sous-traitants", "Hébergement infogéré, Stripe (paiements), et un prestataire d'envoi d'emails transactionnels. Ces prestataires présentent des garanties conformes au RGPD."],
      ["6. Durée de conservation", "Les données sont conservées pendant la durée de l'abonnement. Après fermeture du compte, les données personnelles sont supprimées sous 30 jours ; les factures sont conservées 10 ans (obligation légale)."],
      ["7. Vos droits", "Vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité. L'export de vos données et la fermeture du compte sont disponibles dans Paramètres → Confidentialité."],
    ],
  },
  mentions: {
    title: "Mentions légales",
    testid: "legal-mentions",
    sections: [
      ["Éditeur", `Le Service ${APP} est édité par l'exploitant du logiciel. Coordonnées disponibles sur demande via le support.`],
      ["Hébergement", "Le Service est hébergé sur une infrastructure cloud infogérée au sein de l'Union Européenne."],
      ["Propriété intellectuelle", `L'ensemble des éléments du Service (marque, interface, code) est protégé. Toute reproduction non autorisée est interdite.`],
      ["Contact", "Pour toute question relative au Service ou à vos données, contactez le support depuis votre espace."],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.cgu;
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4" data-testid={d.testid}>
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-2xl bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <ShieldCheck className="w-6 h-6 text-black" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-emerald-600 font-semibold">{APP}</div>
            <h1 className="font-heading text-2xl font-extrabold text-slate-900">{d.title}</h1>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-6">
          {d.sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-heading text-base font-bold text-slate-900 mb-1.5">{h}</h2>
              <p className="text-sm text-slate-600 leading-relaxed">{body}</p>
            </section>
          ))}
          <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">Dernière mise à jour : juin 2026.</p>
        </div>
        <div className="mt-6 flex flex-wrap gap-4 text-xs text-slate-500">
          <a href="/cgu" className="hover:text-emerald-600">CGU</a>
          <a href="/confidentialite" className="hover:text-emerald-600">Confidentialité</a>
          <a href="/mentions-legales" className="hover:text-emerald-600">Mentions légales</a>
          <a href="/login" className="hover:text-emerald-600 ml-auto">Retour à la connexion</a>
        </div>
      </div>
    </div>
  );
}
